import { toast as toastify } from "react-toastify";

function getHotToast() {
  try {
    // Optional: available in ClientZone shell, not in AdminZone bundle.
    // eslint-disable-next-line global-require, import/no-extraneous-dependencies
    return require("react-hot-toast").toast;
  } catch {
    return null;
  }
}

export function notifyError(message, { useHotToast = false } = {}) {
  const text = String(message || "Something went wrong.");
  if (useHotToast) {
    const hotToast = getHotToast();
    if (hotToast) {
      hotToast.error(text);
      return;
    }
  }
  toastify.error(text);
}

export function notifySuccess(message, { useHotToast = false } = {}) {
  const text = String(message || "Saved successfully.");
  if (useHotToast) {
    const hotToast = getHotToast();
    if (hotToast) {
      hotToast.success(text);
      return;
    }
  }
  toastify.success(text);
}
